<template>
  <div class="admin-page">
    <h2>Admin Profile</h2>
    <p>This is Admin Profile page.</p>
  </div>
</template>

<script setup>
</script>

<style scoped>
.admin-page {
  padding: 20px;
}
</style>